export class StringUtil {
  static ALLOWED_CHARS = /^[A-Za-z0-9àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ!@#$%^&€*()_+\-=\\[\]{};'’:",.<>? /\r\n]*$/;

  static appendAllIfExist(phrase: string, separator?: string, ...args: any[]): string {
    let result = phrase;
    args.forEach(it => {
      if (it) {
        if (separator) {
          result = result.concat(separator + it);
        } else {
          result = result.concat(it);
        }
      }
    });
    return result;
  }

  static nice([...array]): string {
    return array.concat(array.splice(-2, 2).join(' et ')).join(', ');
  }
}
